import React from 'react';
import {Box, Text, Rating, RangeSlider, RangeSliderThumb, DateRangePickerNative, Stack} from '@lego/klik-ui';

import { ControlledDropdown } from "./ControlledDropdown";

function App() {

  return (
    <Stack>
      <Box p={4}>
        <Text mt="4" fontWeight={700}>Rating</Text>
        <Rating value={3}></Rating>
      </Box>

      <Box p={4}>
        <Text mt="4" fontWeight={700}>RangeSlider</Text>
        <RangeSlider max={100} min={0} mt={4}>
          <RangeSliderThumb aria-label="Minimum" defaultValue={20} index={0} />
          <RangeSliderThumb aria-label="Maximum" defaultValue={80} index={1} />
        </RangeSlider>
      </Box>

      <Box p={4}>
        <Text mt="4" fontWeight={700}>Datepicker</Text>
        <DateRangePickerNative>
          <DateRangePickerNative.DatePicker label="Departure" />
          <DateRangePickerNative.DatePicker label="Arrival" />
        </DateRangePickerNative>
      </Box>

      <Box p={4}>
        <Text mt="4" fontWeight={700}>Dropdown</Text>
        <ControlledDropdown />
      </Box>

    
    </Stack>
  );
}

export default App;
